"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_AREA_FOCUS = exports.TEXT_AREA_SUCCESS = exports.TEXT_AREA_ERROR = exports.TEXT_AREA_THEME = exports.TEXT_AREA_DISABLED = void 0;
exports.TEXT_AREA_DISABLED = 'data-disabled';
exports.TEXT_AREA_THEME = 'data-theme';
exports.TEXT_AREA_ERROR = 'data-error';
exports.TEXT_AREA_SUCCESS = 'data-success';
exports.TEXT_AREA_FOCUS = 'data-focused';
//# sourceMappingURL=dataKeys.js.map